import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import {
  CarpartsPlusGoldLogo,
  CPPlusGoldUnion,
} from '@usap/uicomponents'
import GTM from '../../../../../helpers/GTM'

import {
  StyledCPFREE,
  StyledCPRewards,
  StyledFrame1,
  StyledCarPartsFree,
  StyledSuggestionRow,
  StyledVehicleLabel,
  StyledFrame2,
  StyledEarnText,
  StyledBoldSpan,
  StyledNormalSpan,
  StyledLinkSpan,
  StyledIconWrapper,
  StyledTooltipnew,
  StyledPointsApplytoSubtotal,
  StyledPointsApply,
  StyledArrow,
  StyledSkeletonContainer,
  StyledSkeletonHeader,
  StyledSkeletonRow,
  StyledSkeletonLine,
  StyledBoldSpan2,
  StyledBonusDaysAlert,
  StyledBonusdaysAlertDetails,
} from './LoyaltyPointsBanner.css'

type LoyaltyPointsBannerProps = {
  points: number
  onSignInClick: () => void
  onRedeemClick: () => void
  isGuest: boolean
  loyaltyRewards: number | null
  redeemableAmount: number | null
  isCouponApplied?: boolean
  isOrderConfirmation?: boolean
  loyaltyBonus?: Array<any> | null | undefined
  memberType?: boolean
}

const InfoIcon = ({ setShowTooltip }) => (
  <svg
    width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', cursor: 'pointer' }}
    onClick={() => setShowTooltip((prev: any) => !prev)}
  >
    <g clipPath="url(#clip0_8667_19951)">
      <path d="M7.00033 12.8332C10.222 12.8332 12.8337 10.2215 12.8337 6.99984C12.8337 3.77818 10.222 1.1665 7.00033 1.1665C3.77866 1.1665 1.16699 3.77818 1.16699 6.99984C1.16699 10.2215 3.77866 12.8332 7.00033 12.8332Z" stroke="#3E3E47" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 9.33333V7" stroke="#3E3E47" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 4.6665H7.00583" stroke="#3E3E47" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_8667_19951">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const ToolTipArrowDown = () => (
  <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.24315 4.90107C5.47854 6.26037 3.52146 6.26037 2.75685 4.90106L6.99382e-07 -7.86805e-07L9 0L6.24315 4.90107Z" fill="white"/>
  </svg>
)

export const LoyaltyPointsBanner = ({
  points,
  onSignInClick,
  onRedeemClick,
  isGuest,
  loyaltyRewards,
  redeemableAmount,
  isCouponApplied,
  isOrderConfirmation = false,
  loyaltyBonus,
  memberType,
}: LoyaltyPointsBannerProps) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [arrowRight, setArrowRight] = useState(17)
  const iconRef = useRef<HTMLSpanElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const tooltipRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!showTooltip) return
    const handleOutsideClick = (e: MouseEvent) => {
      const clickedTooltip = tooltipRef.current?.contains(e.target as Node)
      const clickedIcon = iconRef.current?.contains(e.target as Node)
      if (!clickedTooltip && !clickedIcon) {
        setShowTooltip(false)
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [showTooltip])

  useLayoutEffect(() => {
    if (showTooltip && iconRef.current && containerRef.current) {
      const iconRect = iconRef.current.getBoundingClientRect()
      const containerRect = containerRef.current.getBoundingClientRect()
      setArrowRight(containerRect.right - iconRect.left - iconRect.width / 2 - 4.5)
    }
  }, [showTooltip])

  return (
  <StyledCPFREE ref={containerRef} data-test-id="loyalty-points-banner">
    <StyledCPRewards>
      <StyledFrame1>
        <StyledCarPartsFree>
          <CarpartsPlusGoldLogo />
        </StyledCarPartsFree>
      </StyledFrame1>
      <CPPlusGoldUnion />
    </StyledCPRewards>
    {loyaltyBonus && (
      <StyledBonusDaysAlert>
          <StyledBonusdaysAlertDetails>{`Bonus Days Alert | ${loyaltyBonus?.join('|')}`}</StyledBonusdaysAlertDetails>
      </StyledBonusDaysAlert>
    )}
    <StyledSuggestionRow>
      <StyledVehicleLabel>
        <StyledFrame2>
          <StyledEarnText>
            {isOrderConfirmation ? (
              <>
                {memberType ? (
                  <StyledBoldSpan2> {`You've earned ${points} points on this order! Gold Members earn 3x points.`} </StyledBoldSpan2>
                ) : (
                  <StyledBoldSpan2> {`You've earned ${points} points on this order!`} </StyledBoldSpan2>
                )}
                <StyledLinkSpan href='/my-membership' target='_blank'>View Rewards Balance</StyledLinkSpan>
              </>
            ) : (
              <>
                {loyaltyRewards && (redeemableAmount || 0) > 0 && !isCouponApplied ? (
                  <>
                    <StyledBoldSpan2> {`Redeem points to get $${redeemableAmount} off this order!`} </StyledBoldSpan2>
                    <StyledLinkSpan onClick={() => {
                      GTM?.fireLoayaltyEventCartCheckout({ event: 'cart_redeem_cta_engagement' })
                      onRedeemClick()
                    }}>Redeem Reward</StyledLinkSpan>
                  </>
                ) : (
                  <>
                    {isGuest ? (
                      <>
                        <StyledBoldSpan>{`You'll earn ${points} points on this order`}</StyledBoldSpan>
                        <StyledNormalSpan> +25 points for new members </StyledNormalSpan>
                        <StyledLinkSpan onClick={onSignInClick}>Sign In / Create Account</StyledLinkSpan>
                      </>
                    ) : (
                      <>
                        {memberType ? (
                          <StyledBoldSpan>{`Earn ${points} points on this cart! Gold Members earn 3x points.`}</StyledBoldSpan>
                        ) : (
                          <StyledBoldSpan>{`Earn ${points} points on this cart!`}</StyledBoldSpan>
                        )}
                        <StyledNormalSpan> Place your order to lock them in. </StyledNormalSpan>
                      </>
                    )}
                    <StyledIconWrapper ref={iconRef}>
                      <InfoIcon setShowTooltip={setShowTooltip} />
                    </StyledIconWrapper>
                  </>
                )}
              </>
            )}
          </StyledEarnText>
        </StyledFrame2>
      </StyledVehicleLabel>
    </StyledSuggestionRow>
    {showTooltip && (
      <StyledTooltipnew ref={tooltipRef}>
        <StyledPointsApplytoSubtotal>
          <StyledPointsApply>Points apply to subtotal only. Excludes shipping and taxes.</StyledPointsApply>
        </StyledPointsApplytoSubtotal>
        <StyledArrow style={{ right: arrowRight }}>
          <ToolTipArrowDown />
        </StyledArrow>
      </StyledTooltipnew>
    )}
  </StyledCPFREE>
  )
}

export const LoyaltyPointsBannerSkeleton = () => (
  <StyledSkeletonContainer>
    <StyledSkeletonHeader />
    <StyledSkeletonRow>
      <StyledSkeletonLine width="75%" />
      <StyledSkeletonLine width="55%" />
      <StyledSkeletonLine width="45%" />
    </StyledSkeletonRow>
  </StyledSkeletonContainer>
)
